import { useCallback, useEffect, ReactNode } from 'react';
import ReactDOM from 'react-dom';
import Logger from 'js-logger';

let popoutWindow: Window | null;
const popoutContainer: HTMLElement = document.createElement('div');

const getWindowFeatures = (): string => {
  return [
    'location=0', // location bar / address bar
    'menubar=0',
    'personalbar=0',
    'status=0',
    'titlebar=0',
    'toolbar=0', // navigation toolbar (back, forward, reload, stop buttons)
    `height=${window.innerHeight}`, // height of content area
    `width=${window.innerWidth}` // width of content area
  ].join(',');
};

interface PortalProps {
  children: ReactNode;
  onClosePopout: Function;
  onPopoutBlocked: Function;
  title: string;
}

const WindowPortal = (props: PortalProps) => {
  const { onClosePopout, onPopoutBlocked, title } = props;

  const closePopout = useCallback(() => {
    onClosePopout();
  }, [onClosePopout]);

  useEffect(() => {
    popoutWindow = window.open('', 'lsPopoutWindow', getWindowFeatures());
    // IMPORTANT: don't close popoutwindow from this component because portal window content will get erased by its parent and
    // popout window will remain open. popoutWindowHandle will be called in parent component just before unmounts to close it.
    // @ts-ignore
    window.popoutWindowHandle = popoutWindow;
    if (popoutWindow) {
      popoutWindow.document.title = title;
      popoutWindow.onunload = closePopout; // when the popout window is closed manually by closing the window
      popoutWindow.document.body.appendChild(popoutContainer);
    }
    if (!popoutWindow || popoutWindow.closed || typeof popoutWindow.closed === 'undefined') {
      Logger.info('Popout Window Blocked');
      onPopoutBlocked();
      closePopout();
    }
  }, [closePopout, onPopoutBlocked, title]);

  return ReactDOM.createPortal(props.children, popoutContainer);
};

export default WindowPortal;
